module.exports = __webpack_public_path__ + "static/reception-cc3b405468816fab59d73347ec055c85.png";